import { Directive } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserStorage } from '@scisys-uim/uim-common';
import { TextSection, TEXT_SECTION_TYPE } from 'assets-model';
import { TextSectionService } from 'assets-service';
import { BasePersistentTextSectionComponent } from '../base-persistent-text-section.component';


@Directive()
export abstract class BasePersistentTextSectionEntityComponent extends BasePersistentTextSectionComponent<TextSection> {

  constructor(protected textSectionService: TextSectionService,
    protected userStorage: UserStorage,
    protected snackbar: MatSnackBar) {
    super(userStorage, snackbar);
  }

  performSave() {
    return this.textSectionService.save(this.textSection);
  }
  performLoad() {
    return this.textSectionService.get(this.section);
  }

  protected isEditAvailable(): boolean {
    return this.userStorage.currentUserHasAnyAuthority(TEXT_SECTION_TYPE.editAuthorities);
  }

  isLoaded(): boolean {
    return this.textSection != null;
  }

  getText(): string {
    return this.textSection?.text;
  }

  setText(text: string) {
    if (this.textSection) {
      this.textSection.text = text || "";
    }
  }
}
